import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({ name: 'fromNow' })
export class FromNowPipe implements PipeTransform {
  transform(date?: string | Date): string {
    const mDate = moment(date);
    return mDate.isValid() ? mDate.fromNow() : '';
  }
}
